import { Injectable } from '@angular/core';
import { MatDialog } from "@angular/material/dialog";
import { ComponentType } from "@angular/cdk/portal";
import { MatDialogRef } from "@angular/material/dialog/dialog-ref";

export enum CosmosDialogStyle {
  Dark = 'cosmos-dialog-wrapper-dark',
  Gray = 'cosmos-dialog-wrapper-gray',
}

@Injectable({
  providedIn: 'root',
})
export class CosmosDialogService {
  public constructor(private readonly _dialog: MatDialog) {
  }

  public open<T, D = any, R = any>(
    component: ComponentType<T>,
    config: { data?: D, style: CosmosDialogStyle } = { style: CosmosDialogStyle.Dark },
  ): MatDialogRef<T, R> {
    return this._dialog.open<T, D, R>(component, {
      data: config.data,
      panelClass: ['cosmos-dialog-container', config.style],
    });
  }
}
